import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

import { File, FileDetail } from "./File";

import { useLanguage } from "@hooks/useLanguage";

interface FileRowType {
  label?: string;
  required?: boolean;
  disabled?: boolean;
  acceptImage?: boolean;
  customRow?: JSX.Element;
  register: any;
  name: string;
  control: any;
  setValue: any;
  error?: any;
  fileTypes?: { label?: string; maxSize?: string };
  fileDetails?: FileDetail[];
  isSingle?: boolean;
}

export const FileRow = ({
  register,
  name,
  label,
  required,
  control,
  error,
  setValue,
  disabled,
  acceptImage,
  customRow,
  fileDetails,
  isSingle,
}: FileRowType) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <div className="row">
      <div className="col-lg-3">
        <Text weight="semibold" color="title" size="sm">
          {label
            ? t(`${label}.LABEL`)
            : language === "en"
            ? "Upload File"
            : "ফাইল আপলোড করুন"}
        </Text>
        {required && <span className="text-danger">&#42;</span>}
      </div>
      <div className="col-lg-7">
        <File
          id={name}
          control={control}
          setValue={setValue}
          register={register}
          errors={error}
          disabled={disabled}
          acceptImage={acceptImage}
          customRow={customRow}
          fileDetails={fileDetails}
          isSingle={isSingle}
        />
      </div>
    </div>
  );
};
